import { render, staticRenderFns } from "./WarningCard.vue?vue&type=template&id=27b677c5&scoped=true"
import script from "./WarningCard.vue?vue&type=script&lang=js"
export * from "./WarningCard.vue?vue&type=script&lang=js"
import style0 from "./WarningCard.vue?vue&type=style&index=0&id=27b677c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b677c5",
  null
  
)

export default component.exports